/**
 * Metro's web `import.meta` polyfill (`unstable_transformImportMeta` in
 * babel.config.js) resolves `import.meta.url` via
 * `globalThis.__ExpoImportMetaRegistry.url`, which in turn reads
 * `document.currentScript?.src`. That works for code running at the top
 * level of a `<script>` tag, but the heavy half of @react-pdf/renderer
 * (yoga-layout, pdfkit) only runs once the dynamic `import()` in the caller
 * actually executes it — by which point the `<script>` that fetched the
 * chunk has already finished and `document.currentScript` is back to
 * `null`. pdfkit's browser build does
 * `new URL('./data/sRGB_IEC61966_2_1.icc', import.meta.url)` at module load
 * time, so `new URL(relative, null)` throws "Failed to construct 'URL':
 * Invalid base URL" before the document ever renders — confirmed by
 * reproducing it directly against the exported bundle. Metro's registry
 * object is a plain writable data property, not a getter, so it can be
 * reassigned outright. That ICC profile is only ever fetched for PDF/A
 * output, which this document never requests, so a same-origin fallback
 * is enough to satisfy the constructor without changing behavior.
 */
export function ensureImportMetaRegistry(): void {
  if (typeof window === 'undefined') return;
  const globalWithRegistry = globalThis as { __ExpoImportMetaRegistry?: { url: string } };
  if (globalWithRegistry.__ExpoImportMetaRegistry?.url) return;
  globalWithRegistry.__ExpoImportMetaRegistry = {
    get url() {
      return window.location.href;
    },
  };
}
